<template>
  <router-view />
</template>
<script>
import { onMounted } from "vue";
import { tracker } from "@/main";

export default {
  name: "App",
  setup() {
    onMounted(() => {
      const integratedUserVuex = JSON.parse(
        localStorage.getItem("integratedUserVuex"),
      );
      const userInfo = integratedUserVuex?.userInfo;
      const userName = userInfo?.userName;
      if (userName) {
        tracker.setUserID(userName);
      }
    });
  },
};
</script>
<style lang="scss"></style>
